import {
  TransactionWebPage,
  type ProgressiveTransactionAdapter,
  type ProgressiveTransactionFetchInput,
  type ProgressiveTransactionItem,
  type ProgressiveTransactionRiskFetchInput,
} from '@fe-progressive/package-progressive';
import '@fe-progressive/package-progressive/transaction-web/style.css';
import globalStore from '@/services/global.state';
import {copyText, goBack, toPriceStr} from '@/utils';
import dayjs from 'dayjs';
import React from 'react';
import {getList, getRiskList, getTabs} from './transaction-service';

function formatAmount(amount: number) {
  return toPriceStr(amount, {
    thousands: true,
    fixed: 2,
    spacing: true,
    currency: globalStore.currency,
  });
}

function mapTransactionItem(item: any): ProgressiveTransactionItem {
  return {
    ...item,
    id: item.order,
    appDate: item.appDate,
    balance: item.balance,
    changeType: item.changeType,
    gameName: item.gameName,
    iconUrl: item.iconUrl,
    order: item.order,
    payType: item.payType,
    payTypeName: item.payTypeName,
    price: item.price,
    reward: item.reward,
    walletDetailStatus: item.walletDetailStatus,
    raw: item,
  };
}

export default function TransactionsProgressive() {
  const [amount, setAmount] = React.useState(globalStore.userAmount || 0);

  React.useEffect(() => {
    const sub = globalStore.amountChanged.subscribe(res => {
      setAmount(res.current);
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);

  const adapter = React.useMemo<ProgressiveTransactionAdapter>(
    () => ({
      fetchTabs: async () =>
        (await getTabs()).map(tab => ({
          type: tab.type,
          typeName: tab.typeName,
          hide: Boolean(tab.hide?.length),
        })),
      fetchTransactions: async (input: ProgressiveTransactionFetchInput) => {
        const res = await getList({
          pageNo: input.pageNo,
          pageSize: input.pageSize,
          changeDesc: String(input.tabType),
          yearMonth: input.yearMonth,
        });
        return res.map(mapTransactionItem);
      },
      fetchRiskTransactions: async (
        input: ProgressiveTransactionRiskFetchInput,
      ) => {
        const res = await getRiskList({
          pageNo: input.pageNo,
          changeDesc: input.tabType,
          yearMonth: input.yearMonth,
          status: input.riskStatus,
        });
        return res.map(mapTransactionItem);
      },
      copyText: (text: string) => copyText(text),
      showToast: (notice: {message: string}) =>
        globalStore.globalSucessTotal(notice.message),
    }),
    [],
  );

  return (
    <TransactionWebPage
      adapter={adapter}
      amount={amount}
      onBack={goBack}
      formatAmount={formatAmount}
      formatTime={(time?: number) =>
        time ? dayjs(Number(time)).format('DD/MM/YYYY hh:mm') : ''
      }
    />
  );
}
